const states = {
  downtime_details: {
    downtime_list: [],
    loaders: {
      downtime_loading: false,
      downtime_loaded: false,
      downtime_updating: false,
    }
  },
};

export default states;


// WEBPACK FOOTER //
// ./src/data/redux/downtime_details/states.js